import React, { useContext, useEffect, useRef } from 'react';
import { AppContext } from '../../../../Context/AppContext';
import { fetchBiaValidationCheckData } from './BiaUtils';
import { BiaTable } from './BiaTable';
import { BiaTableContainer } from './BiaReports.style';
import { ASIA_JAPAN } from '../../../../api/constants';
import isEqual from 'lodash/isEqual';

export const DataValidationCheckView = () => {
  const { state, dispatch } = useContext(AppContext).biaReports;
  const { state: appDataState } = useContext(AppContext).appData;
  let userRegion = localStorage.getItem('userRegion') ?? appDataState.userRegion;
  const isAsiaUser =
    localStorage.getItem('isAsiaUser') !== null
      ? localStorage.getItem('isAsiaUser') === 'true'
      : appDataState.userRegionFlags.isAsiaUser;
  const isRegionSpecificUser = Object.values(appDataState.userRegionFlags).some((el) => el);
  const prevFilteredValuesRef = useRef(state.biaFilterData);

  useEffect(() => {
    // This triggers for when the filter values change for all roles
    if (!isEqual(prevFilteredValuesRef.current, state.biaFilterData)) {
      fetchData();
      // Update the refs with the current values
      prevFilteredValuesRef.current = state.biaFilterData;
    }
  }, [dispatch, state.biaFilterData]);

  useEffect(() => {
    // For Global role
    if (!isRegionSpecificUser) {
      fetchData();
    }
  }, []);

  const fetchData = async () => {
    const { biaRegion } = state.biaFilterData;
    if (isAsiaUser) {
      userRegion = ASIA_JAPAN;
    }
    const paramRegion = userRegion ?? biaRegion;
    fetchBiaValidationCheckData(state, dispatch, paramRegion);
  };

  const description = isAsiaUser
    ? 'Gross Bilateral Traded Volume vs Volume By NCF Category - Data Validation Check'
    : 'Gross Physical Traded Volume vs Volume By NCF Category - Data Validation Check';
  return (
    <BiaTableContainer>
      <BiaTable
        description={description}
        isLoading={state.isValidationDataLoading}
        loadingText='validation check data'
        biaData={state.biaValidationCheckData}
        dataTestId='bia-data-validation-check-table-container'
      />
    </BiaTableContainer>
  );
};